export const TYPE_CRYSTAL = 'crystal';
export const TYPE_TOOTH = 'tooth';

export const MENU = [
  {
    'name': 'Classic Crystals',
    'type': TYPE_CRYSTAL,
    'images': ['Classic_Crystal_1', 'Classic_Crystal_2'],
    'prices': [25, 40],
    'description': null,
  },
  {
    'name': 'Coloured Crystals',
    'type': TYPE_CRYSTAL,
    'images': ['Coloured_Crystal_1', 'Coloured_Crystal_2'],
    'prices': [30, 50],
    'description': null,
  },
  {
    'name': 'Shaped Crystals',
    'type': TYPE_CRYSTAL,
    'images': ['Shaped_Crystal_1', 'Shaped_Crystal_2'],
    'prices': [35, 60],
    'description': null,
  },
  {
    'name': 'Crystal Mickey',
    'type': TYPE_TOOTH,
    'images': ['Mickey_1', 'Mickey_2'],
    'prices': [70],
    'description': null,
  },
  {
    'name': 'Cross',
    'type': TYPE_TOOTH,
    'images': ['Cross_1', 'Cross_2'],
    'prices': [80],
    'description': null,
  },
  {
    'name': 'Crystal Window',
    'type': TYPE_TOOTH,
    'images': ['Crystal_Window_1', 'Crystal_Window_2'],
    'prices': [100],
    'description': null,
  },
  {
    'name': 'Crystal Ball',
    'type': TYPE_TOOTH,
    'images': ['Crystal_Ball_1', 'Crystal_Ball_2'],
    'prices': [100],
    'description': 'Full tooth',
  },
  {
    'name': 'Diamond Dust',
    'type': TYPE_TOOTH,
    'images': ['Diamond_Dust_1', 'Diamond_Dust_2'],
    'prices': [120],
    'description': 'Cut crystals, full tooth',
  },
  {
    'name': 'Basic Gold & white Gold',
    'type': TYPE_TOOTH,
    'images': ['Basic_Gold_1'],
    'prices': ['80-90'],
    'description': 'Moon, teardrop, heart, star etc.',
  },
  {
    'name': 'Classic Gold & White Gold',
    'type': TYPE_TOOTH,
    'images': ['Classic_Gold_1', 'Classic_Gold_2'],
    'prices': ['100-110'],
    'description': 'Weed leaf, anchor, cross etc.',
  },
  {
    'name': 'Bespoke Gold & White Gold',
    'type': TYPE_TOOTH,
    'images': ['Bespoke_Gold_1', 'Bespoke_Gold_2'],
    'prices': ['120-130'],
    'description': 'Playboy, rose, designer brand, skull etc.',
  },
  {
    'name': 'Gold & White Gold with Diamonds',
    'type': TYPE_TOOTH,
    'images': ['Gold_Diamond_1'],
    'prices': ['140-150'],
    'description': null,
  },
];
